module.exports = __webpack_public_path__ + "img/ltkstyletip-2x.65f13e0.jpg";